<section class="popup-page">
  <header>
    <button type="button" class="icon-button" (click)="back()" [disabled]="isLoading" [attr.aria-label]="'PROFILE_POPUP_BACK' | translate">&#8249;</button>
    <h2>{{ 'PROFILE_POPUP_ADD_ACCESS' | translate }}</h2>
    <button type="button" class="icon-button" (click)="close()" [disabled]="isLoading" [attr.aria-label]="'CLOSE' | translate">&#215;</button>
  </header>
  <h3 id="assign-user-type-title">{{ 'USER_TYPE' | translate }}</h3>
  <p class="subtitle">{{ 'PROFILE_POPUP_GRANT_ACCESS_BY_USER_TYPE' | translate }}</p>
  <div class="options" role="radiogroup" aria-labelledby="assign-user-type-title">
    <button
      *ngFor="let option of options"
      type="button"
      class="option"
      role="radio"
      [class.selected]="selectedType === option.value"
      [attr.aria-checked]="selectedType === option.value"
      (click)="select(option)"
    >
      <span class="option-body">
        <span class="option-label">{{ option.labelKey | translate }}</span>
        <span *ngIf="option.contactRequired" class="badge">{{ 'PROFILE_POPUP_EMAIL_PHONE_REQUIRED' | translate }}</span>
        <span *ngIf="selectedType === option.value" class="description">{{ option.descriptionKey | translate }}</span>
      </span>
      <span class="radio" aria-hidden="true">
        <mat-icon *ngIf="selectedType === option.value">check</mat-icon>
      </span>
    </button>
  </div>
  <button type="button" class="primary-button" [disabled]="!selectedType || isLoading" (click)="continue()">
    {{ 'CONTINUE' | translate }}
  </button>
</section>
